import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import ScreenLoader from "./components/ScreenLoader";
import { analytics } from "./libs/analyticsLib";
import Utility from "./models/Utility";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./index.scss";

const init = async () => {
	analytics.init();

	const config = await Utility.getConfig();

	ReactDOM.render(
		<>
			<Suspense fallback={<ScreenLoader></ScreenLoader>}>
				<Router>
					<App config={config} />
				</Router>
			</Suspense>
		</>,
		document.getElementById("root")
	);
};
init();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
